import React from 'react';
import { useNavigate } from 'react-router-dom';

function TopNavBar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear session data
    sessionStorage.removeItem('adminSession');
    // Redirect to login page
    navigate('/admin-login');
  };

  return (
    <>
      <div className="top-navbar flex-between gap-16">
        <div className="flex-align gap-16">
          {/* Toggle Button Start */}
          <button
            type="button"
            className="toggle-btn d-xl-none d-flex text-26 text-gray-500"
          >
            <i className="ph ph-list" />
          </button>
          {/* Toggle Button End */}
          {/* <form action="#" class="w-350 d-sm-block d-none">
            <div class="position-relative">
                <button type="submit" class="input-icon text-xl d-flex text-gray-100 pointer-event-none"><i class="ph ph-magnifying-glass"></i></button>
                <input type="text" class="form-control ps-40 h-40 border-transparent focus-border-main-600 bg-main-50 rounded-pill placeholder-15" placeholder="Search...">
            </div>
          </form> */}
        </div>
        <div className="flex-align gap-16">
          <div className="flex-align gap-8"></div>
          {/* User Profile Start */}
          <div className="dropdown">
            <button
              className="users arrow-down-icon border border-gray-200 rounded-pill p-4 d-inline-block pe-40 position-relative"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="position-relative">
                <img
                  src="/assets/images/logo/smmlogo.png"
                  alt="Image"
                  className="h-32 w-32 rounded-circle"
                />
                <span className="activation-badge w-8 h-8 position-absolute inset-block-end-0 inset-inline-end-0" />
              </span>
            </button>
            <div className="dropdown-menu dropdown-menu--lg border-0 bg-transparent p-0">
              <div className="card border border-gray-100 rounded-12 box-shadow-custom">
                <div className="card-body">
                  <div className="flex-align gap-8 mb-20 pb-20 border-bottom border-gray-100">
                    <img
                      src="/assets/images/logo/smmlogo.png"
                      alt=""
                      className="w-54 h-54 rounded-circle"
                    />
                    <div className="">
                      <h4 className="mb-0">Administrator</h4>
                      <p className="fw-medium text-13 text-gray-200">
                        IFM Edu Academy
                      </p>
                    </div>
                  </div>
                  <ul className="max-h-270 overflow-y-auto scroll-sm pe-4">
                    <li className="mb-4">
                      <a
                        href="/admin-profile"
                        className="py-12 text-15 px-20 hover-bg-gray-50 text-gray-300 rounded-8 flex-align gap-8 fw-medium text-15"
                      >
                        <span className="text-2xl text-primary-600 d-flex">
                          <i className="ph ph-gear" />
                        </span>
                        <span className="text">My Profile</span>
                      </a>
                    </li>
                    <li className="pt-8 border-top border-gray-100">
                      <button
                        onClick={handleLogout}
                        className="py-12 text-15 px-20 hover-bg-danger-50 text-gray-300 hover-text-danger-600 rounded-8 flex-align gap-8 fw-medium text-15 w-100 text-start"
                      >
                        <span className="text-2xl text-danger-600 d-flex">
                          <i className="ph ph-sign-out" />
                        </span>
                        <span className="text">Log Out</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* User Profile End */}
        </div>
      </div>
    </>
  );
}

export default TopNavBar;